import axios from 'axios';

export const setAxiosAuthHeader = jwt => {
    axios.defaults.headers.Authorization = `Bearer ${jwt}`;
};
